import React, { useEffect } from 'react';
import { useApiIsLoaded, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

export interface mapProps {
	name?: string;
	latitude: number;
	longitude: number;
}
interface props {
	locations: mapProps[];
}

export default function GoogleMapBounder({ locations }: props) {
	const apiIsLoaded = useApiIsLoaded();
	const map = useMap();

	const visualizationLib = useMapsLibrary('visualization');

	useEffect(() => {
		if (!visualizationLib || !map) return;

		const heatmap = new visualizationLib.HeatmapLayer({
			data: locations.map((place) => new google.maps.LatLng(place.latitude, place.latitude)),
			radius: 50,
		});
		heatmap.setMap(map);
	}, [visualizationLib, map, locations]);

	useEffect(() => {
		if (!apiIsLoaded || !map) return;

		const maps = google.maps;

		const bounds = new maps.LatLngBounds();

		locations.forEach((place) => {
			bounds.extend(new google.maps.LatLng(place.latitude, place.longitude));
		});

		map.fitBounds(bounds);
		google.maps.event.addListenerOnce(map, 'idle', () => {
			google.maps.event.addListener(window, 'resize', () => {
				map.fitBounds(bounds);
			});
		});
	}, [apiIsLoaded, locations, map]);

	return <></>;
}
